import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import SeoMeta from "../../components/SeoMeta";
import PageTitle from "./components/PageTitle";
import LatestPhoto from "./components/LatestPhoto";
import LatestKitchen from "./components/LatestKitchen";
import LatestEvents from "./components/LatestEvents";
import { useLoading } from "../../contexts/LoadingContext"; // ✅ import spinner context

function Home() {
  const { t } = useTranslation();
  const { setIsLoading } = useLoading();

  useEffect(() => {
    setIsLoading(true);
    const timeout = setTimeout(() => {
      setIsLoading(false); // simulate load complete after delay
    }, 500); // you can increase if needed

    return () => clearTimeout(timeout);
  }, [setIsLoading]);

  return (
    <>
     <SeoMeta
        description={t("home.SeoDescription", "I'm Alberto Lussana, an Italian based in Madrid. If I see something, I can photograph it, cook it, or visit it. And one does not exclude the other.")}
        keywords={t("home.SeoKeywords", "digital communication, visual storytelling, photography, technology, marketing, automation, creativity, strategy, user-centered design, cultural exploration, analog photography, digital minimalism, multidisciplinary, remote work, human-centered tech.")}
        robots="index, follow"
      />

      <section className="py-15 py-xl-20">
        <PageTitle />
        <LatestEvents />
        <LatestPhoto />
        <LatestKitchen />
      </section>
    </>
  );
}

export default Home;

